export default __webpack_public_path__ + "static/O0240-13d85d8676c6e117ef0c8ccb42508d84.png";